import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../../assets/xpdlogo.png";
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import {
  Card,
  CardContent,
  Container,
  Typography,
  Box,
  ToggleButton,
  IconButton,
  ToggleButtonGroup,
  Divider,
  Button,
  MenuItem,
  Select,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputLabel,
  styled,
  Chip,
  Paper,
  Grid
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MovingIcon from "@mui/icons-material/Moving";
import QRCode from "react-qr-code"; // npm install react-qr-code
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import BtcIcon from "../../assets/btc.svg";
import UsdtIcon from "../../assets/usdt.svg";
import EthIcon from "../../assets/eth.svg";
import UsdcIcon from "../../assets/usdc.svg";
import WithdrawDialog from "./WalletWithdraw";

import jsPDF from "jspdf";
import TransactionDetailsDialog from "./TransactionDetailsDialog";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#542374',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#542374',
    }
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#542374'
  }
}));

const StyledMenuItem = styled(MenuItem)({
  padding: '10px 16px',
  '&.Mui-selected': {
    backgroundColor: 'rgba(84, 35, 116, 0.08)',
    '&:hover': {
      backgroundColor: 'rgba(84, 35, 116, 0.12)'
    }
  }
});
// Common Select Props
const selectProps = {
  MenuProps: {
    PaperProps: {
      sx: {
        borderRadius: '8px',
        mt: 1,
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
      }
    }
  }
};
const Wallets = () => {
  const VISIBLE_FIELDS = [
    { field: "timestamp", headerName: "Date/Time", width: 200 },
    { field: "coin", headerName: "Coin", width: 100 },
    { field: "from_address", headerName: "From", width: 250 },
    { field: "to_address", headerName: "To", width: 250 },
    { field: "amount", headerName: "Amount", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => (
        params.value === "0x1" ? (
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              color: "green",
              fontWeight: "bold",
            }}
          >
            <span
              style={{
                width: 8,
                height: 8,
                backgroundColor: "green",
                borderRadius: "50%",
                display: "inline-block",
                marginRight: 8,
              }}
            ></span>
            Completed
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            {params.value || "N/A"}
          </Typography>
        )
      ),
    },
    {
      field: "actions",
      headerName: "",
      width: 100,
      renderCell: (params) => (
        <IconButton
          aria-label="details"
          size="small"
          onClick={() => handleTransactionDetailsOpen(params.row)}
        >
          <ArrowForwardIosIcon fontSize="inherit" />
        </IconButton>
      ),
    },
  ];

  const navigate = useNavigate();
  const [cryptoAccounts, setCryptoAccounts] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("USDT");
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [showBalances, setShowBalances] = useState(false);
  const [loading, setLoading] = useState(true);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [withdrawDialogOpen, setWithdrawDialogOpen] = useState(false);
  const [transactionDetailsDialogOpen, setTransactionDetailsDialogOpen] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [withdrawDetails, setWithdrawDetails] = useState({
    address: "",
    amount: "",
    networkFee: 0.01, // Example network fee
  });

  //wallet dialogue
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);

  const handleTransactionClick = (transactionId) => {
    setSelectedTransactionId(transactionId);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedTransactionId(null);
  };
  const [isPrinting, setIsPrinting] = useState(false);
  const receiptRef = useRef(null);

  useEffect(() => {
    const fetchAccountsData = async () => {
      try {
        const token = Cookies.get("token");
        const email = Cookies.get("email");

        const response = await axios.get(`/api/api/v1/getListOfWallets`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { email },
        });

        const mappedAccounts = response.data.map((wallet) => ({
          currency: wallet.coin,
          currencyName: wallet.coin,
          symbol: wallet.coin === "BTC" ? "₿" : wallet.coin === "ETH" ? "Ξ" : "₮",
          balance: wallet.available_balance,
          onHold: wallet.pending_balance,
          icon: wallet.coin === "BTC" ? BtcIcon : wallet.coin === "ETH" ? EthIcon : wallet.coin === "USDT" ? UsdtIcon : UsdcIcon,
          address: wallet.asset_address,
          network: wallet.path,
          transactions: wallet.transactions.map(tx => ({
            ...tx,
            coin: wallet.coin,
            wallet_address: wallet.asset_address
        })) || [],
        }));
        const coinOrder = ["BTC", "ETH", "USDT", "USDC"];

        mappedAccounts.sort((a, b) => {
          const indexA = coinOrder.indexOf(a.currency);
          const indexB = coinOrder.indexOf(b.currency);

          return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });
        setCryptoAccounts(mappedAccounts);

        const initialAccount = mappedAccounts.find((acc) => acc.currency === selectedCurrency);
        if (initialAccount) {
          setSelectedNetwork(initialAccount.network);
          // sort transactions by timestamp in descending order
          const sortedTransactions = initialAccount.transactions.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
          setSelectedTransactions(sortedTransactions);
        }
      } catch (error) {
        console.error("Error fetching wallets data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAccountsData();
  }, [selectedCurrency]);

  const handleCurrencyChange = (event, newCurrency) => {
    if (newCurrency !== null) {
      setSelectedCurrency(newCurrency);

      const account = cryptoAccounts.find((acc) => acc.currency === newCurrency);
      if (account) {
        setSelectedNetwork(account.network);
        // sort transactions by timestamp in descending order
        const sortedTransactions = account.transactions.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setSelectedTransactions(sortedTransactions);
      }
    }
  };

  const handleNetworkChange = (event) => {
    const newNetwork = event.target.value;
    setSelectedNetwork(newNetwork);

    // Find the account for the selected currency and network
    const account = cryptoAccounts.find(
      (acc) => acc.currency === selectedCurrency && acc.network === newNetwork
    );

    if (account) {
      setSelectedTransactions(account.transactions); // Update transactions
      setShowBalances(false); // Optionally hide balances for security
    }
  };

  const handleAddDialogOpen = () => setAddDialogOpen(true);
  const handleAddDialogClose = () => setAddDialogOpen(false);

  const handleWithdrawDialogOpen = () => setWithdrawDialogOpen(true);
  const handleWithdrawDialogClose = () => setWithdrawDialogOpen(false);

  const handleWithdrawChange = (field, value) => {
    setWithdrawDetails((prev) => ({ ...prev, [field]: value }));
  };

  const handleTransactionDetailsOpen = (transaction) => {
    setTransactionDetails(transaction);
    setTransactionDetailsDialogOpen(true);
  };

  const handleTransactionDetailsClose = () => {
    setTransactionDetailsDialogOpen(false);
    setTransactionDetails(null);
  };

  // const handleDownloadPDF = () => {
  //   if (!transactionDetails) return;

  //   const doc = new jsPDF();
  //   doc.setFontSize(12);
  //   doc.text("Transaction Details", 10, 10);

  //   Object.entries(transactionDetails).forEach(([key, value], index) => {
  //     doc.text(`${key}: ${value}`, 10, 20 + index * 10);
  //   });

  //   doc.save("transaction-details.pdf");
  // };






  // rgb(241 244 250)
  return (
    <Container maxWidth="100" sx={{ backgroundColor: "#f5f5f5" }}>
      <Card sx={{ borderRadius: 4, boxShadow: 0, mt: 2 }}>
        <CardContent>
          <Typography variant="body1" color="#7517a7" fontWeight="bold">
            My Balances
          </Typography>
          {/* <Box sx={{ textAlign: "center", mt: 2, }}> */}
          <Box
            sx={{
              // width: '100%',
              textAlign: "center",
              mt: 2,
              overflow: "auto",
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar for Chrome/Safari
              },
              msOverflowStyle: "none", // Hide scrollbar for IE/Edge
              scrollbarWidth: "none", // Hide scrollbar for Firefox
            }}
          >
            <ToggleButtonGroup
              value={selectedCurrency}
              exclusive
              onChange={handleCurrencyChange}
              sx={{
                backgroundColor: "#f6f6f9",
                borderRadius: 2,
                padding: 1,
                display: "inline-flex", // Keep buttons in one line
                width: { xs: "max-content", md: "max-content" }, // Allow horizontal scroll on mobile
              }}
            >
              {Array.from(new Set(cryptoAccounts.map((a) => a.currency))).map(
                (currency) => {
                  const icon = cryptoAccounts.find(
                    (acc) => acc.currency === currency
                  )?.icon;
                  return (
                    <ToggleButton
                      key={currency}
                      value={currency}
                      sx={{
                        borderRadius: "4px",
                        border: "none",
                        px: { xs: 1.5, sm: 2 }, // Slightly reduced padding on mobile
                        py: 1,
                        mx: 1,
                        color: "#542a74",
                        transition: "all 0.2s ease",
                        whiteSpace: "nowrap", // Prevent text wrapping
                        fontSize: { xs: "13px", sm: "14px" }, // Slightly smaller font on mobile
                        "&.Mui-selected": {
                          borderRadius: "4px",
                          mx: 1,
                          backgroundColor:
                            currency === "BTC"
                              ? "#f7931a30"
                              : currency === "ETH"
                                ? "#79767240"
                                : currency === "USDT"
                                  ? "#50af9530"
                                  : "#2775ca30",
                          color: "#542a74",
                          "&:hover": {
                            borderRadius: "4px",
                            backgroundColor:
                              currency === "BTC"
                                ? "#f7931a40"
                                : currency === "ETH"
                                  ? "#79767250"
                                  : currency === "USDT"
                                    ? "#50af9540"
                                    : "#2775ca40",
                          },
                        },
                        "&:hover": {
                          borderRadius: "4px",
                          backgroundColor:
                            currency === "BTC"
                              ? "#f7931a20"
                              : currency === "ETH"
                                ? "#79767230"
                                : currency === "USDT"
                                  ? "#50af9520"
                                  : "#2775ca20",
                        },
                        "&.Mui-selected.Mui-focused": {
                          borderRadius: "4px",
                          backgroundColor:
                            currency === "BTC"
                              ? "#f7931a30"
                              : currency === "ETH"
                                ? "#79767240"
                                : currency === "USDT"
                                  ? "#50af9530"
                                  : "#2775ca30",
                        },
                      }}
                    >
                      <img
                        src={icon}
                        alt={currency}
                        style={{
                          width: 18,
                          height: 18,
                          marginRight: 6,
                          flexShrink: 0, // Prevent image from shrinking
                        }}
                      />
                      {currency}
                    </ToggleButton>
                  );
                }
              )}
            </ToggleButtonGroup>
          </Box>

          {cryptoAccounts.filter((acc) => acc.currency === selectedCurrency)
            .length > 1 && (
              <Box display="flex" justifyContent="center" mt={3}>
                <FormControl fullWidth size="small" sx={{ maxWidth: 200 }}>
                  <Select
                    value={selectedNetwork}
                    onChange={handleNetworkChange}
                    displayEmpty
                  >
                    {cryptoAccounts
                      .filter((acc) => acc.currency === selectedCurrency)
                      .map((acc) => (
                        <MenuItem key={acc.network} value={acc.network}>
                          {acc.network}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>
            )}

<Box mt={4}>
  {selectedCurrency === "BTCS" ? (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        px: 4,
        py: 2,
      }}
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        color="text.secondary"
        sx={{ textAlign: "center" }}
      >
        Available Soon
      </Typography>
    </Box>
  ) : (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <Typography variant="h6" fontWeight="bold">
          {selectedCurrency} Balances
        </Typography>
        <IconButton onClick={() => setShowBalances(!showBalances)}>
          {showBalances ? (
            <RemoveRedEyeOutlinedIcon color="primary" />
          ) : (
            <VisibilityOffOutlinedIcon color="primary" />
          )}
        </IconButton>
      </Box>

      <Box
        mt={2}
        display="flex"
        justifyContent="center"
        gap={4}
        px={4}
        py={2}
        sx={{ backgroundColor: "#fff", borderRadius: 2 }}
      >
        <Box textAlign="center">
          <Typography variant="body2" color="text.secondary">
            Available
          </Typography>
          <Typography
            variant="h6"
            fontWeight="bold"
            color="primary"
            sx={{ textAlign: "center" }}
          >
            {showBalances
              ? `${cryptoAccounts.find(
                  (acc) =>
                    acc.currency === selectedCurrency &&
                    acc.network === selectedNetwork
                )?.symbol || ""
              } ${cryptoAccounts.find(
                  (acc) =>
                    acc.currency === selectedCurrency &&
                    acc.network === selectedNetwork
                )?.balance || "0.0000"
              }`
              : "****"}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box textAlign="center">
          <Typography variant="body2" color="text.secondary">
            Pending
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="secondary">
            {showBalances
              ? `${cryptoAccounts.find(
                  (acc) =>
                    acc.currency === selectedCurrency &&
                    acc.network === selectedNetwork
                )?.symbol || ""
              } ${cryptoAccounts.find(
                  (acc) =>
                    acc.currency === selectedCurrency &&
                    acc.network === selectedNetwork
                )?.onHold || "0.0000"
              }`
              : "****"}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" justifyContent="center" mt={3} gap={2}>
        <Button
          variant="outlined"
          endIcon={<AddCircleIcon />}
          onClick={handleAddDialogOpen}
        >
          Add {selectedCurrency}
        </Button>
        <Button
          variant="outlined"
          endIcon={<MovingIcon />}
          onClick={handleWithdrawDialogOpen}
        >
          Withdraw {selectedCurrency}
        </Button>
      </Box>
    </>
  )}
</Box>
        </CardContent>
      </Card>

      <Card sx={{ borderRadius: 4, boxShadow: 0, mt: 2 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="body1"
              color="#7517a7"
              fontWeight="bold"
              gutterBottom
            >
              Recent Transactions
            </Typography>
            {/* Link for see more */}
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate("/transactions")}
              sx={{ textTransform: "none" }}
            >
              See more
            </Button>
          </Box>
          <Box sx={{ overflowX: "auto", borderRadius: 4, mt: 2 }}>
            {selectedTransactions.length > 0 ? (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  borderRadius: "8px",
                  overflow: "hidden",
                  fontSize: "14px",
                }}
              >
                {/* Table Header */}
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5", textAlign: "left" }}>
                    <th style={{ padding: "12px", fontWeight: "bold" }}>
                      Date/Time
                    </th>
                    <th style={{ padding: "12px", fontWeight: "bold" }}>
                      Coin
                    </th>
                    <th style={{ padding: "12px", fontWeight: "bold" }}>
                      Wallet Address
                    </th>
                    {/* <th style={{ padding: "12px", fontWeight: "bold" }}>To</th> */}
                    <th style={{ padding: "12px", fontWeight: "bold" }}>
                      Amount
                    </th>
                    <th style={{ padding: "12px", fontWeight: "bold" }}>
                      Status
                    </th>
                    <th style={{ padding: "12px", fontWeight: "bold" }}></th>
                  </tr>
                </thead>

                {/* Table Body */}
                <tbody>
                  {selectedTransactions.slice(0, 5).map((tx, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      <td style={{ padding: "12px" }}>
                        {tx.timestamp ? (
                          new Date(tx.timestamp).toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>{selectedCurrency}</td>
                      <td style={{ padding: "12px" }}>
                        {tx.wallet_address || "N/A"}
                      </td>
                      {/* <td style={{ padding: "12px" }}>
                        {tx.to_address || "N/A"}
                      </td> */}
                      <td style={{ padding: "12px" }}>{tx.amount || "N/A"}</td>
                      <td style={{ padding: "12px" }}>
                        {tx.status === "0x1" ? (
                          <Typography
                            variant="body2"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              color: "green",
                              fontWeight: "bold",
                            }}
                          >
                            <span
                              style={{
                                width: 8,
                                height: 8,
                                backgroundColor: "green",
                                borderRadius: "50%",
                                display: "inline-block",
                                marginRight: 8,
                              }}
                            ></span>
                            Completed
                          </Typography>
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              color: "orange",
                              fontWeight: "bold",
                            }}
                          >
                            <span
                              style={{
                                width: 8,
                                height: 8,
                                backgroundColor: "orange",
                                borderRadius: "50%",
                                display: "inline-block",
                                marginRight: 8,
                              }}
                            ></span>
                            Processing
                          </Typography>
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        <IconButton
                          aria-label="details"
                          size="small"
                          onClick={() => handleTransactionClick(tx.id)}
                        >
                          <ArrowForwardIosIcon fontSize="inherit" />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ textAlign: "center", mt: 2 }}
              >
                No transactions found
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Transaction Details Dialog */}
      {/* <Dialog
        open={transactionDetailsDialogOpen}
        onClose={handleTransactionDetailsClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Transaction Details</DialogTitle>
        <DialogContent>
          {transactionDetails ? (
            <Box>
              {Object.entries(transactionDetails).map(([key, value]) => (
                <Typography key={key} variant="body2" gutterBottom>
                  <strong>{key}:</strong> {value || "N/A"}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography variant="body2">No details available.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTransactionDetailsClose}>Close</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownloadPDF}
          >
            Download PDF
          </Button>
        </DialogActions>
      </Dialog> */}
      <TransactionDetailsDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        transactionId={selectedTransactionId}
      />



      {/* Add Dialog */}
      <Dialog open={addDialogOpen} onClose={handleAddDialogClose}>
  <DialogTitle>Add Funds</DialogTitle>
  <DialogContent>
    {selectedCurrency === "BTCS" ? (
      <Typography
        variant="body1"
        fontWeight="bold"
        color="text.secondary"
        sx={{ textAlign: "center", mt: 2 }}
      >
        Available Soon
      </Typography>
    ) : (
      <>
        {/* Coin Selection */}
        <StyledFormControl fullWidth margin="normal">
          <InputLabel>Coin</InputLabel>
          <Select
            value={selectedCurrency}
            onChange={(e) => handleCurrencyChange(null, e.target.value)}
            label="Coin"
            MenuProps={{
              PaperProps: {
                sx: {
                  borderRadius: "8px",
                  mt: 1,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                },
              },
            }}
          >
            {Array.from(
              new Set(cryptoAccounts.map((acc) => acc.currency))
            ).map((currency) => {
              const cryptoAccount = cryptoAccounts.find(
                (acc) => acc.currency === currency
              );
              return (
                <StyledMenuItem key={currency} value={currency}>
                  {currency}
                </StyledMenuItem>
              );
            })}
          </Select>
        </StyledFormControl>

        {/* Network Selection (only if available) */}
        {cryptoAccounts.filter((acc) => acc.currency === selectedCurrency)
          .length > 1 && (
          <StyledFormControl fullWidth margin="normal">
            <InputLabel>Network</InputLabel>
            <Select
              value={selectedNetwork}
              onChange={(e) => setSelectedNetwork(e.target.value)}
              label="Network"
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  },
                },
              }}
            >
              {cryptoAccounts
                .filter((acc) => acc.currency === selectedCurrency)
                .map((acc) => (
                  <StyledMenuItem key={acc.network} value={acc.network}>
                    {acc.network}
                  </StyledMenuItem>
                ))}
            </Select>
          </StyledFormControl>
        )}

        {/* Wallet Address and QR Code */}
        <Typography variant="body2" gutterBottom>
          Wallet Address:
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{
                wordBreak: { xs: "break-all", sm: "normal" },
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              {cryptoAccounts.find(
                (acc) =>
                  acc.currency === selectedCurrency &&
                  acc.network === selectedNetwork
              )?.address || "N/A"}
            </Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const address = cryptoAccounts.find(
                (acc) =>
                  acc.currency === selectedCurrency &&
                  acc.network === selectedNetwork
              )?.address;
              if (address) {
                navigator.clipboard.writeText(address);
                alert("Wallet address copied to clipboard!");
              }
            }}
            sx={{
              minWidth: { xs: "100%", sm: "auto" },
              mt: { xs: 1, sm: 0 },
              whiteSpace: "nowrap",
            }}
          >
            Copy
          </Button>
        </Box>

        <Box display="flex" justifyContent="center" mt={2}>
          <QRCode
            value={
              cryptoAccounts.find(
                (acc) =>
                  acc.currency === selectedCurrency &&
                  acc.network === selectedNetwork
              )?.address || ""
            }
            size={150}
          />
        </Box>
      </>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleAddDialogClose}>Close</Button>
  </DialogActions>
</Dialog>

      {/* Withdraw Dialog */}
      <WithdrawDialog
  open={withdrawDialogOpen}
  onClose={handleWithdrawDialogClose}
  initialCoin="BTC" // Pass the initial coin
  initialNetwork="Bitcoin" // Pass the initial network
/>
    </Container>
  );
};

export default Wallets;